import { render, staticRenderFns } from "./NewsQuery.vue?vue&type=template&id=d9bae654&scoped=true&"
import script from "./NewsQuery.vue?vue&type=script&lang=js&"
export * from "./NewsQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bae654",
  null
  
)

export default component.exports